"use client";
import notFoundImage from "@/assets/svgs/errorPage404.svg";
import Image from "next/image";
import "./not-found.css";
import ButtonAnimated from "@/components/ButtonAnimated/ButtonAnimated";

function NotFound() {
  return (
    <div className="NotFound">
      <div className="NotFound-wrapper">
        <Image
          src={notFoundImage}
          alt="Seite nicht gefunden"
          className="NotFound-image"
        />

        <h2 className="NotFound-title">Seite nicht gefunden</h2>

        <p className="NotFound-text">
          Die Seite, nach der du gesucht hast,
          <br /> konnte nicht gefunden werden.
        </p>

        <ButtonAnimated
          text="Startseite"
          fill="#fff"
          color="#fff"
          fontSize="22px"
          link="/"
        />
      </div>
    </div>
  );
}

export default NotFound;
